<template>
    <div>
        <app-text
            label="Name"
            :data-source="'deha.user.misc.partners.' + listitemId + '.data.name'"
            :data-default="{ type: 'raw', value: 'Ihr Partner' }"
            required
            :maxlength="255"
        ></app-text>

        <app-text
            label="Link zur Website"
            :data-source="'deha.user.misc.partners.' + listitemId + '.data.link'"
            :data-default="{ type: 'raw', value: 'https://www.tecworld.com' }"
            pattern="^(https?:\/\/(www\.)?)?[\-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([\-a-zA-Z0-9@:%_\+.~#?\&\/\/=]*)$"
            autoformat="url"
            :maxlength="255"
        ></app-text>

        <app-filepicker
            label="Partner Logo"
            :data-source="'deha.user.misc.partners.' + listitemId + '.data.image'"
            :data-default="{ type: 'file' }"
            file-namespace="images/partners/default"
            accept=".jpg,.png,.gif"
        ></app-filepicker>
    </div>
</template>

<script>
import Text from '@/components/fields/simple/Text.vue';
import Filepicker from '@/components/fields/complex/Filepicker.vue';

export default {
    data() {
        return {};
    },
    methods: {},
    computed: {},
    mounted() {
        this.$emit('controlhead', {
            title: this.$helpers.uiText('R034'),
            help: this.$helpers.uiText('R035'),
            removeText: this.$helpers.uiText('R036')
        });
    },
    props: {
        moduleId: String,
        listitemId: String
    },
    components: {
        'app-text': Text,
        'app-filepicker': Filepicker
    }
};
</script>
